import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  ...enLocale,
  menu: {
    'Home': 'Home',
    '404': '404',
    '403': '403',
    '500': '500',
    'Login': 'Login',
    'AuditProcess': 'Audit',
    'UserManage': 'User',
    'UserManageList': 'User Info',
    'UserWhiteList': 'User Whitelist',
    'CloseUserRecord': 'Close User Record',
    'CreditWhiteList': 'Credit WhiteList',
    'Financial': 'Financial',
    'TransactionManageList': 'Transaction',
    'MerchantWithdrawConfirm': 'Withdrawal',
    'CollectionManage': 'Post-loan',
    'RepaymentPlanList': 'User to be repaid',
    'FlatAccountRecords': 'Reconciliation Record',
    'Marketing': 'Marketing',
    'CommentsList': 'App CommentsList',
    'Configuration': 'Configuration',
    'FaqManageList': 'FAQ',
    'System': 'System',
    'SystemDepartment': 'Company Structure',
    'SystemUser': 'User',
    'SystemRole': 'Role',
    'SystemPermission': 'Permission',
    'SystemMenu': 'Menu',
  },

  page: {
    'Home': 'Home',
    '404': '404',
    '403': '403',
    '500': '500',
    'Login': 'Login',
    'Upload': 'Upload',
    user: 'User',
    'app:user:manage': 'User Info',
    'app:user:userWhiteList': 'User Whitelist',
    'app:user:closeUserRecord': 'Close User Record',
    'app:user:manage:detailInfo': 'User Info Detail',
    'app:user:manage:auditDetailInfo': 'User Info Auit Detail',
    'app:user:creditWhiteList': 'Credit WhiteList',
    'operation:feedback': 'Feedback',
    'app:user:tadpole': 'Tadpole Loan User Management',
    financial: 'Financial',
    'transaction:manage': 'Transaction',
    'merchant:withdraw:confirm': 'Withdrawal',
    'debtBuyback:manage': 'Debt Buyback',
    collection: 'Post-loan',
    'collection:manage:repaymentPlanList': 'User to be repaid',
    'collection:manage:flatAccountRecords': 'Reconciliation Record',
    marketing: 'Marketing',
    'app:commentsList:manage': 'App CommentsList',
    'coupon': 'Coupon',
    notice: 'Notice',
    'notice:job:list': 'Job',
    'notice:sql:list': 'SQL',
    'notice:tmp:list': 'Template',
    'notice:job:jobExecuteLog': 'Job Execute Log',
    'notice:weight': 'Notification Weight',
    'notice:successRate': 'Success Rate',
    'notice:blackList': 'Black List',
    order: 'Order',
    'app:order:quickloan': 'Quick Loan',
    'app:order:cashoyo': 'Cashoyo Loan',
    'order:cashoyoLoan': 'Cashoyo Loan',
    'order:consumeList': 'User consumption order',
    'order:refundList': 'Refund processing record',
    mpay: 'MPay',
    'mpay:reconciliation': 'MPay',
    'mpay:reconciliation:list': 'MPay Reconciliation',
    'mpay:reconciliation:cps': 'CPS Reconciliation',
    'mpay:reconciliation:fixlog': 'Fix Log',
    'mpay:cashFlowAnalysis': 'Mpay Cash Flow Analysis',
    configuration: 'Configuration',
    'shortLink:manage': 'Short Link (Manual)',
    'shortLinkAuto:manage': 'Short Link (Auto)',
    'faq:manage': 'FAQ',
    'app:banner:manage': 'Banner',
    'app:category:manage': 'Category',
    
    system: 'System',
    'system:department': 'Company Structure',
    'system:user': 'User',
    'system:role': 'Role',
    'system:menu': 'Menu',
    'system:log': 'Operation log',
    'app:announcement:manage': 'Announcement',
    product: 'B/L/E Maintenance',
    'product:category': 'Category',
    'product:brand': 'Brand List',
    'product:productListByVendor': 'Product List by Vendor/Channel',
    'funder': 'Funder',
    'funder:routerList': 'Funder Router',
    'funder:checkOrderList': 'Check Order',
    'funder:ownbankRepaymentList': 'Ownbank Repayment',
    'funder:ownbankStatementList': 'Ownbank Statement',
    'funder:ownbankPayoutList': 'Ownbank Payout',
    'funder:getIncomeLoanList': 'GetIncome Loan',
    loanMarket: 'Loan Manage',
    'loanMarket:merchantProductList': 'Merchant Product List',
    'loanMarket:parentList': 'Partner List',
    'loanMarket:parentFrontList': 'Inform Partner List',
    'loanMarket:merchantList': 'Merchant List',
    'loanMarket:tagList': 'Tag List',
    'loanMarket:merchantProductList:detailInfo': 'Merchant Product Detail',
    'loanMarket:showConfigList': 'Show Config',
    complaint: 'Complaint Management',
    'complaint:pendingList': 'Pending Complaints',
    'complaint:processedList': 'Resolved Complaints',
      tele: 'Tele Manage',
      'tele:cases': 'Case List',
      'tele:cases:detail': 'Case Detail',
      'tele:ccbar': 'Telesales Agent ',
      'tele:caseAppoint': 'Appoint Case List',
      'tele:callTask': 'Call Task List',
      'tele:strategyList': 'Strategy List'
  },

  'tip:tip': 'Tips',
  'tip:pleaseSelect': 'Please select the data to be operated first',
  'tip:pleaseSelect2': 'Please select a person before clicking',
  'tip:sureSubmit': 'Are you sure to submit?',
  'tip:sureCancel': '`Are you sure to cancel?',
  'tip:sureDelete': 'Are you sure to delete?',
  'tip:selectDelete': 'Please select the object to delete first',
  'tip:operateSuccessTip': 'Operation success',
  'tip:operateErrorTip': 'Operation Failed',
  'tip:sendSmsSuccessTip': 'Send success',
  'tip:sendSmsErrorTip': 'Send Failed',
  'tip:required': 'This is required',
  'tip:amountFormatErrorTip': 'Please enter the correct amount',
  'tip:creditWhiteListErrorTip': 'The withdrawal limit shall not exceed the total limit',
  'tip:upload:uploadBtn': 'Click to upload',
  'tip:upload:uploadTip': 'Please upload [fileTypeName] files and no more than [fileSize] MB',
  'tip:upload:uploadTip2': 'Drag files here, or click Upload',
  'tip:upload:uploadTip3': 'extension support',
  'tip:upload:uploadTip4': 'Please upload the file first',
  'tip:upload:fileTypeTip': 'The file format is incorrect, please upload the file in the following format: [fileTypeName]',
  'tip:upload:fileSizeTip': 'File size cannot exceed [fileSize] MB',
  'tip:upload:uploadSuccess': 'Uploaded successfully',
  'tip:upload:uploadError': 'Upload failed, please try again',
  'tip:upload:uploadLimitError': 'Exceed the number of uploaded files, please delete and upload again later!',
  'tip:sureJoinBlackList': 'Are you sure you want to join the blacklist?',
  'tip:sureRemoveBlackList': 'Are you sure you want to remove the blacklist?',
  'tip:sureEnable': 'Are you sure you want to enable it?',
  'tip:sureDisable': 'Are you sure you want to disable it?',
  'tip:validatorNumber': 'Please fill in the number',
  'tip:validatorNumber1': 'Please enter a correct number, not a decimal',
  'tip:validatorNumber2': 'Please enter a number with up to 1 decimal places',
  'tip:validatorNumber3': 'Please enter a number up to 100',
  'tip:storeCategoryTip': 'Parent category cannot be itself or its subcategories',
  'tip:logoutReasonRequired': 'Logout reason cannot be empty',
  'tip:sureLogout': 'Are you sure you want to log out?',
  'tip:sureCancelLogout': 'Are you sure you want to restore this user?',
  'tip:sureChangeBankCard': 'Are you sure you want to change your merchant card?',
  'tip:allowEditTip': 'Only approved merchants are allowed to modify, please check',
  'tip:deparentmentTip1': 'The parent department cannot do it for itself',
  'tip:deparentmentTip2': "Cannot modify Mocasa's parent department",
  'tip:businessHoursTip1': 'The start time must be greater than the end time of the previous period',
  'tip:businessHoursTip2': 'End time must be greater than start time',
  'tip:changeTransactionMobileTip': 'The mobile number cannot be repeated, please check',
  'tip:validatorMobile': 'Please enter the correct phone number',
  'tip:changePasswordTips1': 'The password must be 12 characters or longer, consisting of both uppercase and lowercase letters, special characters and numbers. It should also be a strong password that is not consecutive or repetitive.',
  'tip:changePasswordTips2': 'The two newly entered passwords are not the same.',

  'base:userId': 'User Id',
  'base:userName': 'User Name',
  'base:userMobile': 'User Mobile',
  'base:submissionTime': 'Submission Time',
  'base:addBlackTime': 'Block Time',
  'base:variableName': 'Variable Name',
  'base:bdId': 'BD ID',
  'base:bdName': 'BD Name',
  'base:bdNumber': 'BD Number',
  'base:bdAccount': 'BD Account',
  'base:status': 'Status',
  'base:reviewStatus': 'Review Status',
  'base:addReason': 'Reason Added',
  'base:keyword': 'Keyword',
  'base:remark': 'Remark',
  'base:roleName': 'Role Name',
  'base:roleCode': 'Role Code',
  'base:roleDesc': 'Role Desc',
  'base:addTime': 'Date Added',
  'base:createTime': 'Created Time',
  'base:updateTime': 'Updated Time',
  'base:modifiedTime': 'Modified Time',
  'base:createName': 'Create Name',
  'base:updateName': 'Update Name',
  'base:isValid': 'IsValid',
  'base:lastModifyUser': 'Last Update Employee',
  'base:lastModifyTime': 'Last Update Time',
  'base:uploadImg': 'Upload image',
  'base:addressId': 'Address ID',
  'base:addressName': 'Address Name',
  'base:parentAddress': 'Parent Address',
  'base:time': 'Time',
  'base:startTime': 'Start Time',
  'base:endTime': 'End Time',
  'base:onlineReason': 'Reason for going online',
  'base:offlineReason': 'Reason for going offline',
  'base:reason': 'Reason',
  'base:phone': 'Phone Number',
  'base:name': 'Name',
  'base:source': 'Source',
  'base:creditLine': 'Credit Line',
  'base:withdrawLine': 'Withdraw Line',

  'base:feedbackTime': 'Feedback Time',
  'base:feedbackType': 'Feedback Type',
  'base:feedbackType1': 'Complaint',
  'base:feedbackType2': 'Suggestion',
  'base:contactType': 'Contact Type',
  'base:contact': 'Contact Details',
  'base:context': 'Describe',
  'base:uploadPicUrl': 'Photo',
  'base:loanProducts': 'Loan Products',
  'base:replyDialogTitle': 'Feedback Reply',
  'base:replyStatus': 'Status',
  'base:replyStatus0': 'Unprocessed',
  'base:replyStatus1': 'Processed',
  'base:newReplyStatus0': 'Unknown',
  'base:newReplyStatus1': 'Submitted',
  'base:newReplyStatus2': 'Accepted',
  'base:newReplyStatus3': 'In Progress',
  'base:newReplyStatus4': 'Completed',

  'base:operationAccount': 'Operation account',
  'base:operationTime': 'Operation time',
  'base:operationMode': 'Operation module',
  'base:operationType': 'Operation type',
  'base:operationSource': 'Operation Source',
  'base:operationIp': 'Operation IP',
  'base:operationContent': 'Operation content',
  'base:newOrders': 'New Orders',
  'base:reprocess': 'Reprocess',

  'base:sqlId': 'SQL ID',
  'base:sqlName': 'SQL Name',
  'base:filterType': 'Filter Type',
  'base:purpose': 'Purpose',
  'base:tpl': 'Template',
  'base:tplId': 'Template ID',
  'base:tplName': 'Template Name',
  'base:tplTitle': 'Template Title',
  'base:extendJson': 'Extend Json',
  'base:thirdPartTemplate': 'Third Part Template',
  'base:tplContent': 'Template Content',
  'base:JobId': 'Job ID',
  'base:JobName': 'Job Name',
  'base:startDate': 'Start Date',
  'base:sendTime': 'Send Time',
  'base:lastSendTime': 'Last Send Time',
  'base:sendInterval': 'Send Interval(minute)',
  'base:groupName': 'Group Name',
  'base:sendType': 'Send Type',
  'base:contentType': 'Content Type',
  'base:sendRate': 'Send Rate',
  'base:sendCost': 'Send Cost',
  'base:enterSearch': 'Please enter keywords to search',
  'base:jobConfigIds': 'Job Config Ids',
  'base:completeTime': 'Complete Time',
  'base:replaceShortUrl': 'Replace ShortUrl',
  'base:type': 'Type',

  'action:changePassword': 'Change Password',
  'action:add': 'Add',
  'action:batchAdd': 'Batch Add',
  'action:batchOperation': 'Batch Operation',
  'action:view': 'View',
  'action:viewSQL': 'View SQL',
  'action:edit': 'Edit',
  'action:submit': 'Submit',
  'action:confirm': 'Confirm',
  'action:save': 'Save',
  'action:cancel': 'Cancel',
  'action:back': 'Back',
  'action:delete': 'Delete',
  'action:start': 'Start',
  'action:stop': 'Stop',
  'action:batchDelete': 'Batch Delete',
  'action:search': 'Search',
  'action:reset': 'Reset',
  'action:detail': 'Detail',
  'action:operate': 'Operation',
  'action:modify': 'Modify',
  'action:preview': 'Preview',
  'action:more': 'More',
  'action:join': 'Join',
  'action:remove': 'Remove',
  'action:joinBlack': 'Join Blacklist',
  'action:removeBlack': 'Remove Blacklist',
  'action:updateCreditLine': 'UpdateCreditLine',
  'action:raise': '₱ Raise',
  'action:batchRaise': '₱ Batch Raise',
  'action:logout': 'Logout',
  'action:cancelLogout': 'Restore',
  'action:assignPermission': 'Assign Permission',
  'action:import': 'Import',
  'action:audit': 'Audit',
  'action:downloadTemplate': 'Download template',
  'action:pass': 'Pass',
  'action:reject': 'Reject',
  'action:refundAction': 'Action',
  'action:refund': 'Refund',
  'acton:reply': 'Reply',
  'action:viewEdit': 'View&Edit',
  'action:enable': 'Enable',
  'action:disable': 'Disable',
  'action:changeMobile': 'Change Mobile',
  'action:fix': 'Fix',
  'action:jobConfig': 'Job Config',
  'action:testSend': 'Test Send',
  'action:smsTestSend': 'SMS Test Send',
  'action:sms': 'SMS',

  'enum:joined': 'joined',
  'enum:removed': 'removed',

  'enum:auditStatus0': 'Initial status',
  'enum:auditStatus1': 'To be reviewed',
  'enum:auditStatus2': 'To be modified',
  'enum:auditStatus3': 'Pass',
  'enum:auditStatus4': 'Rejected',
  'enum:auditStatus5': 'To be signed',

  'enum:userStatus0': 'Normal',
  'enum:userStatus1': 'Locked',
  'enum:customerStatus1': 'normal',
  'enum:customerStatus2': 'lock',
  'enum:customerStatus3': 'black',
  'enum:customerStatus4': 'logout',
  'enum:customerStatus5': 'Reviewed',

  'enum:reviewStatus1': 'Reviewed',
  'enum:reviewStatus0': 'Unprocessed',

  'enum:flatAccountType1': 'Normal repayment',
  'enum:flatAccountType2': 'erased penalty interest',
  'enum:flatAccountType3': 'supplementary repayment',
  'enum:flatAccountType4': 'wage deduction',
  'enum:flatAccountType5': 'marketing budget',
  'enum:flatAccountType6': 'test order',
  'enum:flatAccountType7': 'No handling fee',

  'enum:result0': 'fail',
  'enum:result1': 'success',

  'enum:interestStatus1': 'interest',
  'enum:interestStatus2': 'no interest',
  'enum:interestStatus3': 'pending',
  'enum:visitResult0': 'to be signed',
  'enum:visitResult1': 'Signing contract',
  'enum:visitResult2': 'Contracted',
  'enum:visitResult0': 'to be signed',
  'enum:visitResult1': 'Signing contract',
  'enum:isEffective0': 'Invalid',
  'enum:isEffective1': 'Effective',
  'enum:yes': 'Yes',
  'enum:no': 'No',
  'enum:valid': 'valid',
  'enum:invalid': 'invalid',
  'enum:show': 'show',
  'enum:hide': 'hide',

  'enum:contractStage0': 'generating',
  'enum:contractStage1': 'generated',
  'enum:contractStage2': 'bd checked',
  'enum:contractStage3': 'merchant signed',
  'enum:contractStage4': 'bd signed',
  'enum:contractStage5': 'wait merchant confirm',
  'enum:contractStage6': 'finished',

  'enum:riskCode10': 'suspend trading',
  'enum:riskCode15': 'prohibit withdrawal',
  'enum:riskCode19': 'offline',

  'merchantCheck:search:storeId': 'Store ID',
  'merchantCheck:search:storeName': 'Store Name',
  'merchantCheck:search:merchantMobile': 'Merchant Mobile',
  'merchantCheck:search:merchantId': 'Merchant ID',
  'merchantCheck:search:createTime': 'Create Time',
  'merchantCheck:search:beenReviewed': 'Been Reviewed',
  'merchantCheck:detail:section0:title': 'Additional Information',
  'merchantCheck:detail:registerTime': 'Registration time',
  'merchantCheck:detail:registerPhone': 'Merchant Registered Mobile Number',
  'merchantCheck:detail:submitPhone': 'Submit Phone Number',
  'merchantCheck:detail:applyTime': 'Application Time',
  'merchantCheck:detail:isOpen': 'Status',
  'merchantCheck:detail:openTime': 'Time Online',
  'merchantCheck:detail:bdAccount': 'BD Num',
  'merchantCheck:detail:isAlreadyAudit': 'Been Reviewed',
  'merchantCheck:detail:riskLevel': 'Risk Level',
  'merchantCheck:detail:appealPicture': 'feedback image',
  'merchantCheck:detail:appealVideo': 'feedback video',
  'merchantCheck:detail:appealDesc': 'description',
  'merchantCheck:detail:appealTime': 'Merchant information submission time',
  'merchantCheck:detail:rejectReason': 'Reject Reason',

  'userCheck:detail:black': 'Blacklist',
  'userCheck:detail:blackReason': 'Reason',
  'userCheck:detail:blackReason1': 'Fake ID',
  'userCheck:detail:blackReason2': 'Students/minor age',
  'userCheck:detail:blackReason3': "Fraudulent use other people's documents",
  'userCheck:detail:blackReason4': 'Other',

  'userCheck:detail:selectRejectReason': 'Please select a reason for rejection',
  'userCheck:detail:enterRemark': 'Please add remarks',

  'merchant:table:merchantId': 'Merchant ID',
  'merchant:table:merchantNumber': 'Merchant Number',
  'merchant:table:merchantName': 'Merchant Name',
  'merchant:table:storeName': 'Store Name',
  'merchant:table:storeCategory': 'Store Category',
  'merchant:table:merchantMobile': 'Merchant Mobile',
  'merchant:table:merchantProperty': 'Store Type',
  'merchant:table:photoOfStoreFront': 'Photo of Store Front',
  'merchant:table:moreStorePhotos': 'More Store Photos',
  'merchant:table:industry': 'Industry',
  'merchant:table:address': 'Address',
  'merchant:table:detailAddress': 'Detail Address',
  'merchant:table:longLat': 'longitude&latitude',
  'merchant:table:longitude': 'longitude',
  'merchant:table:latitude': 'latitude',
  'merchant:table:customerServicePhone': 'Customer Service Phone',
  'merchant:table:status': 'Status',
  'merchant:table:createTime': 'Create Time',
  'merchant:table:firstTimeOnline': 'First Time Online',
  'merchant:table:auditResult': 'Audit Status',
  'merchant:table:reviewResult': 'Review Result',
  'merchant:table:flowBackStatus': 'Change Status',
  'merchant:table:fee': 'Fee',
  'merchant:table:accountPeriod': 'Account Period',
  'merchant:table:bdNumber': 'BD Number',
  'merchant:table:bdName': 'BD Name',
  'merchant:table:bdID': 'BD ID',
  'merchant:table:bdMobile': 'BD Mobile',
  'merchant:table:lastModified': 'Last Modified',
  'merchant:table:lastModifiedTime': 'Last Modified Time',
  'merchant:table:operation': 'Operation',
  'merchant:table:riskTime': 'Risk warning time',
  'merchant:table:riskLevel': 'Risk Level',
  'merchant:table:remark': 'Remark',
  'merchant:table:switch': 'Switch',
  'merchant:table:showCartoonPhoto': 'Display specification diagram',
  'merchant:table:showRealPhoto': 'Show real shots',
  'merchant:table:isSupportTakeaway': 'whether to accept delivery',
  'merchant:table:merchantSource': 'Merchant Source',
  'merchant:table:chainStoresNum': 'Number of Chain Stores in the Philippines',
  'merchant:table:contacts': 'contacts',
  'merchant:table:contactName': 'contact [n] name',
  'merchant:table:contactMobile': 'contact [n] mobile',
  'merchant:table:contactEmail': 'contact [n] email',
  'merchant:table:id': 'ID',
  'merchant:table:smsCode': 'Verification Code',
  'merchant:table:smsContent': 'SMS content',
  'merchant:table:sendTime': 'Send Time',
  'merchant:table:workOrderNumber': 'Work Order Number',
  'merchant:table:workOrderContent': 'Follow up question',
  'merchant:table:workOrderLevel': 'Emergency level',
  'merchant:table:workOrderLevel0': 'Low',
  'merchant:table:workOrderLevel1': 'Middle',
  'merchant:table:workOrderLevel2': 'High',
  'merchant:table:workOrderProcess': 'whether to process',
  'merchant:table:workOrderProcess0': 'not processed',
  'merchant:table:workOrderProcess1': 'processed',
  'merchant:table:workOrderResult': 'Process result',
  'merchant:table:selectedReason': 'Recommendation',
  'merchant:table:auditName': 'Audit operator',
  'merchant:table:auditTime': 'Audit operation time',
  'merchant:table:rejectReason': 'Reject Reason',
  'merchant:table:merchantRejectReason': 'Merchant Reject Reason',
  'merchant:table:auditRejectReason': 'Audit Reject Reason',
  'merchant:table:businessHours': 'Business Hours',


  'merchant:detail:tab1': 'Basic Information',
  'merchant:detail:tab2': 'Trading Information',
  'merchant:detail:tab3': 'Related information',
  'merchant:detail:tab4': 'Risk Information',
  'merchant:detail:tab5': 'BD visit record',
  'merchant:detail:tab6': 'Extended information',
  'merchant:detail:tab7': 'Transaction record',
  'merchant:detail:tab8': 'Work order follow record',
  'merchant:detail:tab9': 'Merchant operation record',

  'merchant:detail:applyDate': 'Transaction Time',
  'merchant:detail:applyCount': 'Number of initiating transactions',
  'merchant:detail:applyUserCount': 'Number of initiators',
  'merchant:detail:applyAmount': 'Amount to initiate',
  'merchant:detail:realCount': 'Actual number of transactions',
  'merchant:detail:realUserCount': 'Actual users of transactions',
  'merchant:detail:realAmount': 'Actual transaction amount',
  'merchant:detail:withdrawCount': 'Number of withdrawals',
  'merchant:detail:withdrawAmount': 'Withdrawal amount',
  'merchant:detail:remainAmount': 'Merchant available balance',
  'merchant:detail:receiptUserCount': 'Number of users by billing date',
  'merchant:detail:receiptTransCount': 'Number of transations by billing date',
  'merchant:detail:overdueOccurredTransCount': 'The number of historically overdued transactions by billing date',
  'merchant:detail:receiptUserCountRate': 'Percentage of historically overdued transactions by billing date',
  'merchant:detail:overdueTransCount': 'The number of transactions unsettled until current date',
  'merchant:detail:receiptTransCountRate': 'Percentage of transactions that are unsettled until current date',
  'merchant:detail:withdrawTitle': 'Withdrawal record',
  'merchant:detail:consumeTitle': 'Consume record',
  'merchant:detail:withdrawAmount2': 'Withdrawal amount',
  'merchant:detail:withdrawTime': 'Withdrawal time',
  'merchant:detail:withdrawFailReason': 'Fail Reason',

  'merchant:detail:interestStatus': 'merchant attitude',
  'merchant:detail:visitTime': 'Visit Time',
  'merchant:detail:isEffective': 'Whether the visit is valid',
  'merchant:detail:materialUrl': 'Material',
  'merchant:detail:storeOwnerName': 'Store owner name',
  'merchant:detail:storeOwnerMobile': 'Store owner mobile phone number',
  'merchant:detail:visitResult': 'Visit result',
  'merchant:detail:nextVisitPlan': 'The next visit plan is expected',
  'merchant:detail:nextVisitTime': 'Estimated next visit time',

  'merchant:detail:availableBalance': 'Available balance',
  'merchant:detail:withdrawalAmount': 'Withdrawal amount in process',
  'merchant:detail:amountHeld': 'Amount held',
  'merchant:detail:merchantCreditAmount': 'Amount received by merchant',
  'merchant:detail:sourceAmount': 'User consumption amount',

  'merchant:detail:openingDays': 'Opening Days',
  'merchant:detail:openingDays1': 'Every Day',
  'merchant:detail:openingDays2': 'Select Days',
  'merchant:detail:openingHours': 'Opening Hours',
  'merchant:detail:openingHours1': '24 Hours',
  'merchant:detail:openingHours2': 'Select Times',
  'merchant:detail:openingHoursTip': 'Up to 3 periods of time can be set for daily opening hours',

  'order:table:orderId': 'Order ID',
  'order:table:transactionId': 'Transaction ID',
  'order:table:transactionNumber': 'Transaction serial number',
  'order:table:transactionName': 'Trxn Name',
  'order:table:voghionOrderId': 'Voghion Order No',
  'order:table:serialNumber': 'External Order ID',
  'order:table:payThirdPartSerialNumber': 'nternal Payment ID',
  'order:table:payTransactionId': 'Payment Reference ID',
  'order:table:userName': 'User Name',
  'order:table:mobile': 'User Mobile',
  'order:table:idNumber': 'ID Num',
  'order:table:amount': 'Total Amount',
  'order:table:amount1': 'Amount',
  'order:table:principal': 'Principal',
  'order:table:interest': 'Interest',
  'order:table:penaltyInterest': 'Penalty Interest',
  'repayment:detail:installServiceFee': 'Installment Service Fee',
  'order:table:paidPrincipal': 'Principal Paid',
  'order:table:paidInterest': 'Interest Paid',
  'order:table:paidPenaltyInterest': 'Penalty Interest Paid',
  'order:table:remainingAmount': 'Remaining Amount Due',
  'order:table:flatAccountAmount': 'Repayment Amount',
  'order:table:flatType': 'Account Type',
  'order:table:bankSerialNo': 'Bank serial number',
  'order:table:bankCredentialImgUrl': 'Certificate',
  'order:table:remark': 'Remark',
  'order:table:operateName': 'Operator',
  'order:table:flatAccountType': 'Type',
  'order:table:operateTime': 'Operation time',
  'order:table:result': 'Result',
  'order:operate:flatAccount': 'Reconciliation',
  'order:table:refundStatus': 'Refund status',
  'order:table:refundStatus0': 'To be processed',
  'order:table:refundStatus1': 'Refund successfully',
  'order:table:refundStatus2': 'Refund failed',
  'order:table:refundStatus3': 'Refund pending',
  // 'order:table:refundStatus3': 'Refund failed (B)',
  // 'order:table:refundStatus4': 'Refund failed (C)',
  'order:table:isRefund': 'isRefund',
  'order:table:refundAmount': 'Refund amount',
  'order:table:refundId': 'Refund order number',
  'order:table:refundTime': 'Refund time',
  'order:table:merchantWithdrawalAmount': 'Merchant Available Balance',
  'order:table:actualLoanAmount': 'The actual consumption amount of the user',
  'order:table:loanAmount': 'User consumption amount',
  'order:table:orderAmount': 'User order amount',
  'order:table:actualPayAmount': 'The actual amount paid by the user',
  'order:table:discountAmount': 'Discount amount',
  'order:table:remainingRefundAmount': 'Remaining refundable amount',
  'order:table:consumptionTime': 'Consumption time',
  'order:table:merchantResult': 'Merchant Result',
  'order:table:clientResult': 'MPay Result',
  'order:table:transactionStatus': 'Order Status',
  'order:table:transactionStatus0': 'To be released',
  'order:table:transactionStatus1': 'successful loan',
  'order:table:transactionStatus2': 'Loan failed',
  'order:table:transactionStatus3': 'Loan close',
  'order:table:transactionStatus4': 'full refund',
  'order:table:transactionStatus5': 'Partial refund',
  'order:table:payOrderStatus': 'Order Status',
  'order:table:payOrderStatus0': 'To be paid',
  'order:table:payOrderStatus1': 'payment successful',
  'order:table:payOrderStatus2': 'Payment failed',
  'order:table:payOrderStatus3': 'order closed',
  'order:table:payOrderStatus4': 'full refund',
  'order:table:payOrderStatus5': 'Partial refund',
  'order:table:payOrderStatus6': 'VCC Reversed',
  'order:table:payOrderStatus7': 'VCC Refunded',
  'order:table:withdrawStatus': 'Order Status',
  'order:table:withdrawStatus0': 'To be processed',
  'order:table:withdrawStatus1': 'successful',
  'order:table:withdrawStatus2': 'failed',
  'order:table:withdrawStatus3': 'order closed',
  'order:table:withdrawStatus4': 'full refund',
  'order:table:withdrawStatus5': 'Partial refund',
  'order:operate:applayRefund': 'Refund',
  'order:table:transactionType': 'Transaction type',
  'order:table:transactionOrderType': 'Order Type',
  'order:table:transactionType1': 'consumption order',
  'order:table:transactionType2': 'split order',
  'order:table:transactionType3': 'Withdraw order',
  'order:table:transactionType4': 'Installment order',
  'order:table:transactionType5': 'Installment sub-order',
  'order:table:transactionType6': 'repayment order',
  'order:table:transactionType7': 'reward order',
  'order:table:transactionType8': 'refund order',
  'order:table:transactionType9': 'Cash withdrawal fee',
  'order:table:transactionApplicationTime': 'Transaction application time',
  'order:table:transactionEndTime': 'Transaction end time',
  'order:table:auditStatus': 'Audit result',
  'order:table:auditStatus0': 'pending review',
  'order:table:auditStatus1': 'pass',
  'order:table:auditStatus2': 'reject',
  'order:table:auditStatus3': 'close',
  'order:table:failReason': 'Remark',

  'order:table:orderType': 'Order Type',
  'order:table:orderType1': 'Consume Order',
  'order:table:orderType2': 'Buy Load and Data',
  'order:table:orderType3': 'VOGHION Order',
  'order:table:orderType4': 'Takeout Order',
  'order:table:orderType5': 'Utility Order',
  'order:table:orderType6': 'Cash out',
  'order:table:orderType7': 'Scan to Pay',
  'order:table:orderType8': 'Deposit',
  'order:table:orderType9': 'E-Voucher',
  'order:table:orderType10': 'Credit Reserved',
  'order:table:orderType11': 'Credit Released',
  'order:table:orderType12': 'One-Time Card Order',
  'order:table:orderType13': 'Coupon Pack',
  'order:table:orderType14': 'Card issuing fee',
  'order:table:orderType15': 'QRPH P2M',
  'order:table:orderType16': 'V-Pass',
  'order:table:orderType17': 'Issuing Order - Mocasa Card',
  'order:table:orderType18': 'Issuing Order - Gift Card',
  'order:table:orderType19': 'Transaction - Gift Card',
  'order:table:orderType20': 'Transaction - Mocasa Card',
  'order:table:orderType21': 'Credit Report',
  'order:table:orderType22': 'Insurance',
  'order:table:payTime': 'Payment Time',
  'order:table:payChannel': 'Payment Channel',

  'order:table:detail:goodsAmount': 'Good Amount',
  'order:table:detail:serviceFee': 'Fee',
  'order:table:detail:discountAmount': 'Discount',
  'order:table:detail:paymentAmount': 'Payment Amount',
  'order:table:detail:orderAmount': 'Order Amount',
  'order:table:detail:orderAmount2': 'Total Amount',
  'order:table:detail:supplierName': 'Supplier',
  'order:table:detail:serialNum': 'System ID',
  'order:table:detail:otherNum': 'Partner Reference ID',
  'order:table:detail:merchantId': 'Merchant ID',
  'order:table:detail:merchantName': 'Merchant Name',
  'order:table:detail:customerParam': 'Order Detail（User Input）',
  'order:table:detail:errorJson': 'Order Result',
  'order:table:detail:amountDialogTitle': 'Order Amount Detail',
  'order:table:detail:supplierDialogTitle': 'Supplier Detail',
  'order:table:detail:associateTrxnDialogTitle': 'Associate Transaction Detail',
  'order:table:detail:orderDetailDialogTitle': 'Order Detail',
  'order:table:detail:channelDialogTitle': 'Channel Detail',
  'order:table:detail:repayOrderAmountDialogTitle': 'Repayment Order Amount Detail',

  'order:withdraw:table:applicationTime': 'Application Time',
  'order:withdraw:table:withdrawalAmount': 'Withdrawal Amount',
  'order:withdraw:table:platformFee': 'Platform Fee',
  'order:withdraw:table:actualLoanAmount': 'Actual Loan Amount',
  'order:withdraw:table:paymentType': 'Payment Type',
  'order:withdraw:operate:payment': 'Payment',
  'order:withdraw:operate:cancel': 'Cancel',

  'dept:table:departmentParentId': 'Superior',
  'dept:table:departmentParentName': 'Superior',
  'dept:table:departmentId': 'Department ID',
  'dept:table:departmentName': 'Department Name',
  'dept:table:memberCount': 'On Job Employees',
  'dept:table:sort': 'Sort',
  'dept:table:remark': 'Remark',
  'dept:table:deptManage': 'Department Management',
  'dept:table:keywordsFilter': 'Enter keywords to filter',
  'dept:table:bdAppDisplay': 'BD app needs to be displayed',
  'dept:table:bdAppDisplay0': 'no',
  'dept:table:bdAppDisplay1': 'yes',

  'sys:user:keywords': 'Keywords',
  'sys:user:dept': 'Department',
  'sys:user:superior': 'Superior',
  'sys:user:area': 'Responsible area',
  'sys:user:numberOfStores': 'Responsible for the number of stores',
  'sys:user:name': 'Name',
  'sys:user:role': 'Role',
  'sys:user:userStatus': 'User Status',
  'sys:user:phone': 'Phone Number',
  'sys:user:entryTime': 'Onboarding Time',
  'sys:user:resignationTime': 'Resignation Time',
  'sys:user:workNumber': 'Job Number',
  'sys:user:userName': 'Account Name',
  'sys:user:realName': 'Name',
  'sys:user:mobile': 'Phone Number',
  'sys:user:email': 'Email',
  'sys:user:department': 'Department',
  'sys:user:parentDepartment': 'Parent Department',
  'sys:user:lastLoginTime': 'Last Login Time',
  'sys:user:password': 'Password',
  'sys:user:password2': 'Confirm Password',

  'sys:menu:name': 'Name',
  'sys:menu:menuName': 'Menu Name',
  'sys:menu:menuIcon': 'Menu Icon',
  'sys:menu:menuType': 'Menu Type',
  'sys:menu:parentMenu': 'Parent Menu',
  'sys:menu:menuUrl': 'Menu URL',
  'sys:menu:menuPermissionCode': 'Menu Permission',
  'sys:menu:menuSort': 'Sort',
  'sys:menu:menuType0': 'Directory',
  'sys:menu:menuType1': 'Menu',
  'sys:menu:menuType2': 'Button',

  'user:table:userId': 'User ID',
  'user:table:userName': 'User Name',
  'user:table:email': 'User Email',
  'user:table:userMobile': 'User Mobile',
  'user:table:userSex': 'User Sex',
  'user:table:currentQuota': 'Current Quota',
  'user:table:usedQuota': 'Used Quota',
  'user:table:outstandingQuota': 'Outstanding Quota',
  'user:table:product': 'Product',
  'user:table:registerTime': 'Register Time',
  'user:table:appCode': 'App Code',
  'user:table:systemType': 'System Type',
  'user:table:registerInviteCode': 'Referral Code',
  'user:table:authorization': 'Third-Party Data Authorization',
  'user:table:authorization0': 'Unauthorized',
  'user:table:authorization1': 'Authorized',
  'user:table:authorizationTime': 'Authorization Time',
  'user:table:raiseAmount': 'Adjust amount to',
  'user:table:effectiveDate': 'Effective date',
  'user:table:reason': 'Reason statement',
  'user:table:logoutReason': 'Logout reason',
  'user:table:depositInfo:rechargeAmount': 'recharge Amount',
  'user:table:depositInfo:depositAmount': 'deposit Amount',
  'user:table:depositInfo:activeAmount': 'active Amount',
  'user:table:depositInfo:guaranteeRate': 'guarantee Rate',
  'user:table:giftCardInfo:giftCardTotalAmount': 'Gift Card Total Amount',
  'user:table:giftCardInfo:giftCardAvailableAmount': 'Gift Card Available Amount',
  'user:table:giftCardInfo:templateId': 'Template ID',
  'user:table:giftCardInfo:totalAmount': 'Total Amount',
  'user:table:giftCardInfo:availableAmount': 'Available Amount',
  'user:table:giftCardInfo:status0': 'inactivated',
  'user:table:giftCardInfo:status1': 'activated',
  'user:table:giftCardInfo:status2': 'disabled',
  'user:table:giftCardInfo:status3': 'inactivated(timeout)',
  'user:table:giftCardInfo:activationDate': 'Activation Time',
  'user:table:giftCardInfo:activationDueDate': 'Activation Expiration Time',
  'user:table:originMobile': 'Old Mobile',
  'user:table:replaceMobile': 'New Mobile',
  
  'user:detail:tab1': 'Basic Information',
  'user:detail:tab2': 'Check Information',
  'user:detail:detailInfoTab': 'User Information',
  'user:action:bindReferralCode': 'Bind Referral Code',
  'user:detail:enterNewReferralCode': 'Enter New Referral Code',
  'user:detail:referralCodeFormatTip': '5 Digits or Uppercase Letters',
  'user:detail:reIssueReferralBonus': 'Re-Issue Referral Bonus',
  'user:detail:reIssueReferralBonusDefault': 'Re-Issue Referral Bonus\n*Enter first, then search automatically.',
  'user:detail:noRewardFound': 'No Reward Found',
  'user:detail:userCreatedInviteCode': 'User Created',
  'user:detail:confirmToBind': 'Confirm to Bind',
  'user:detail:bindReferralCodeWarning': 'Once linked to a user, the referral code cannot be changed or revoked.',
  'user:detail:submitInfoTab': 'Credit Record',
  'user:detail:financeUserInfoTab': 'Finance User Info',
  'user:detail:financeUserInfo:id': 'Finance User ID',
  'user:detail:financeUserInfo:createUserId': 'Create User ID',
  'user:detail:applyRecord': 'Apply Record',
  'user:detail:partnerLoanRecord': 'Partner Loan Record',
  'user:detail:depositInfoTab': 'Deposit Information',
  'user:detail:creditInfoTab': 'Quota Information',
  'user:detail:giftCardTab': 'Gift Card Information',
  'user:detail:couponTab': 'Coupon Information',
  'user:detail:consumeTab': 'Order Record',
  'user:detail:transactionTab': 'Transaction Activity',
  'user:detail:repaymentTab': 'Repayment',
  'user:detail:billTab': 'Statement',
  'user:detail:installmentTab': 'Installment History',
  'user:detail:bnplRecommitTime': 'bnpl Recommit Time',
  'user:detail:qlRecommitTime': 'ql Recommit Time',
  'user:detail:viewRepaymentCode': 'View Repayment Code',

  'user:detail:submitInfo:configType': 'Config Type',
  'user:detail:submitInfo:status': 'Status',
  'user:detail:submitInfo:auditTime': 'Audit Time',
  'user:detail:submitInfo:createTime': 'Create Time',

  'user:detail:transactionRecord:merchantId': 'Merchant ID',
  'user:detail:transactionRecord:merchantName': 'Merchant Name',
  'user:detail:transactionRecord:orderType': 'Order Type',
  'user:detail:transactionRecord:orderName': 'Order Name',
  'user:detail:transactionRecord:orderAmount': 'Order Amount',
  'user:detail:transactionRecord:orderTime': 'Order Time',
  'user:detail:transactionRecord:serialNum': 'Order Reference ID',
  'user:detail:transactionRecord:thirdPartSerialNumber': 'Returned Reference ID',
  'user:detail:transactionRecord:payAmount': 'Payment Amount',
  'user:detail:transactionRecord:payThirdPartSerialNumber': 'Internal Payment ID',
  'user:detail:transactionRecord:payTransactionId': 'Payment Reference ID',
  'user:detail:transactionRecord:payTime': 'Payment Time',
  'user:detail:transactionRecord:payMode': 'Payment Provider - Channel',
  'user:detail:transactionRecord:orderStatus': 'Order Status',
  'user:detail:transactionRecord:refundTime': 'Refund Time',
  'user:detail:transactionRecord:refundAmount': 'Refund Amount',
  'user:detail:transactionRecord:customerParam': 'Order Detail',
  'user:detail:transactionRecord:errorJson': 'Failed Reason',
  'user:detail:transactionRecord:supplier': 'Supplier',
  'user:detail:transactionRecord:associateTrxn': 'Associate Trxn',

  'user:detial:quickLoan:currentOrder': 'Current Loan',
  'user:detial:quickLoan:historyOrder': 'History Loan',
  'user:detial:quickLoan:statementDate': 'Due Date',
  'user:detial:quickLoan:overdueDays': 'Overdue Days',

    'user:detial:parntnerLoan:partnerId': 'Partner ID',
  'user:detial:parntnerLoan:partnerName': 'Partner Name',
  'user:detial:parntnerLoan:applyStatus': 'Apply Status',
  'user:detial:parntnerLoan:loanStatus': 'Status',
  'user:detial:parntnerLoan:loanStatus1': 'In Application',
  'user:detial:parntnerLoan:loanStatus2': 'Successful',
  'user:detial:parntnerLoan:loanStatus3': 'Rejected',
  'user:detial:parntnerLoan:loanStatus4': 'Rejected (Data Collision)',
  'user:detial:parntnerLoan:loanStatus5': 'Fake Document',
  'user:detial:parntnerLoan:creditResult': 'Credit Result',
  'user:detial:parntnerLoan:creditLine': 'Credit Line',
  'user:detial:parntnerLoan:finishStatus': 'Finish Status',
  'user:detial:parntnerLoan:finishStatus0': 'Not Completed',
  'user:detial:parntnerLoan:finishStatus1': 'Completed',
  'user:detial:parntnerLoan:createTime': 'Create Time',
  'user:detial:parntnerLoan:updateTime': 'Update Time',
  'user:detial:parntnerLoan:partnerLoanAmount': 'Partner Loan Amount',
  'user:detial:parntnerLoan:repayStatus': 'Status',
  'user:detial:parntnerLoan:repayStatus0': 'Outstanding',
  'user:detial:parntnerLoan:repayStatus1': 'Settled',
  'user:detial:parntnerLoan:loanDate': 'Loan Date',
  'user:detial:parntnerLoan:dueDate': 'Due Date',

  'credit:detail:creditLine': 'Total amount',
  'credit:detail:usedLine': 'Used limit',
  'credit:detail:availableLine': 'Available Credit',
  'credit:detail:enchashmentCredit': 'Cash withdrawal amount',
  'credit:detail:usedEnchashmentCredit': 'Cash withdrawal amount used',
  'credit:detail:availableEnchashmentCredit': 'Available cash withdrawal amount',
  'credit:detail:vccLine': 'vcc amount',
  'credit:detail:usedVccLine': 'Used vcc amount',
  'credit:detail:availableVccLine': 'available vcc amount',
  'credit:detail:overflowAmt': 'Overflow amount',
  'credit:detail:stage': 'Stage type',
  'credit:detail:stage1': 'credit stage',
  'credit:detail:stage2': 'increase stage',
  'credit:detail:pageId': 'PageId',
  'credit:detail:name': 'User Name',
  'credit:detail:status': 'Status',
  'credit:detail:applyTime': 'ApplyTime',
  'credit:detail:auditTime': 'AuditTime',
  'credit:detail:rejectReason': 'RejectReason',
  'credit:detail:lineChange': 'Change amount',
  'credit:detail:lineBefore': 'Amount before change',
  'credit:detail:lineAfter': 'Amount after change',
  'credit:detail:changeTime': 'change time',
  'credit:detail:changeAmount': 'Change amount',
  'credit:detail:latestBalance': 'latest balance',
  'credit:detail:creditLimitChangeRecord':'Credit limit change record',
  'credit:detail:withdrawalChangeRecord':'Cash withdrawal amount change record',
  'credit:detail:creditLimitUseRecord':'Credit limit usage record',

  'coupon:detail:type': 'Coupon Type',
  'coupon:detail:type1': 'Full discount coupon',
  'coupon:detail:type2': 'Interest Free coupon',
  'coupon:detail:amount': 'Coupon amount',
  'coupon:detail:distributeTime': 'DistributeTime',
  'coupon:detail:used': 'Use or not',
  'coupon:detail:useTime': 'UseTime',
  'coupon:detail:useRule': 'UseRule',

  'repayment:detail:applyAmount': 'Repayment Amount',
  'repayment:detail:realAmount': 'Actual payment amount',
  'repayment:detail:repaymentStatus': 'Repayment status',
  'repayment:detail:repaymentStatus0': 'initial',
  'repayment:detail:repaymentStatus1': 'processing',
  'repayment:detail:repaymentStatus2': 'success',
  'repayment:detail:repaymentStatus3': 'failed',
  'repayment:detail:tradeFinishTime': 'Repayment completion time',
  'repayment:detail:paySerialNo': 'SerialNo',
  'repayment:detail:payChannel': 'Pay Channel',
  'repayment:detail:payMode': 'Pay Mode',

  'repayment:detail:nextRepaymentPlanTimee': 'Next accounting period',
  'repayment:detail:unOutAccountAmount': 'Outstanding amount',
  'repayment:detail:billTime': 'Accounting period',
  'repayment:detail:billStartTime': 'Billing start time',
  'repayment:detail:billEndTime': 'Billing end time',
  'repayment:detail:isInstallment': 'Statement Installment',
  'repayment:detail:isRefund': 'Repayment or not',
  'repayment:detail:installPeriod': 'Number of installments',
  'repayment:detail:billAmount': 'Bill amount',
  'repayment:detail:principal': 'Principal',
  'repayment:detail:interest': 'Interest',
  'repayment:detail:charge': 'Charge',
  'repayment:detail:penaltyInterest': 'Penalty Interest',
  'repayment:detail:statementPrincipal': 'Statement Principal',
  'repayment:detail:statementInterest': 'Statement Interest',
  'repayment:detail:statementFee': 'Statement Fee',
  'repayment:detail:repaymentBeforeStatement': 'Repayment before Statement',
  'repayment:detail:repayAmount': 'Repayment amount',
  'repayment:detail:paidTotalAmount': 'Bill paid amount',
  'repayment:detail:contractSerialNo': 'Contract No',
  'repayment:detail:status': 'Repayment status',
  'repayment:detail:status1': 'To be repaid',
  'repayment:detail:status2': 'Past Due',
  'repayment:detail:status3': 'Staged',
  'repayment:detail:status4': 'Paid in full',
  'repayment:detail:status5': 'Paid Minimum Due',
  'repayment:detail:statusNew1': 'To be paid',
  'repayment:detail:statusNew2': 'Minimum Due Paid',
  'repayment:detail:statusNew3': 'Paid in Full (Minimum Due)',
  'repayment:detail:statusNew4': 'Paid in Full',
  'repayment:detail:statusNew5': 'Overdue',
  'repayment:detail:expireTime': 'Repayment deadline',
  'repayment:detail:refundTime': 'Repayment time',
  'repayment:detail:clickViewConsumptionRecord': 'Click to view consumption record',
  'repayment:detail:processFee': 'Processing fee',
  'repayment:detail:channel': 'Payment Channel',
  'repayment:detail:actionDetail': 'Detail',
  'repayment:detail:requestAmount': 'Request Amount',
  'repayment:detail:tradingChannel': 'Channel',
  'repayment:detail:paymentId': 'Payment ID',
  'repayment:detail:statementBeginDate': 'Statement Period',
  'repayment:detail:statementDate': 'Statement Date',
  'repayment:detail:statementBalance': 'Statement Balance',
  'repayment:detail:statementDue': 'Statement Due',
  'repayment:detail:statementStatus': 'Statement Status',
  'repayment:detail:settleAmount': 'Settled Amount',
  'repayment:detail:settleTime': 'Settled Time',
  'repayment:detail:repaymentOrder': 'Repayment Order',
  'repayment:detail:detailInfo': 'Statement Detail',
  'repayment:detail:fee': 'Fee',
  'repayment:detail:penalty': 'Penalty Interest',
  'repayment:detail:detailTotal': 'Amount Total',
  'repayment:detail:detailTotal2': 'Statement Amount Total',
  'repayment:detail:transactionList': 'Transaction List',
  'repayment:detail:nextRepaymentPlanTime': 'Statement Date',
  'repayment:detail:dueDate': 'Due Date',
  'repayment:detail:minRepaymentAmount': 'Minimum Due',
  'repayment:detail:totalDue': 'Total Due',
  'repayment:detail:totalBalance': 'Total Balance',
  'repayment:detail:paidTotalAmount': 'Repayment After Statement',
  'repayment:detail:settledRepayment': 'Settled Repayment',
  'repayment:detail:outstandingBalance': 'Statement Outstanding Balance',
  'repayment:detail:settledRepaymentDetail': 'Settled Repayment Detail',

  'installment:detail:detailInfo': 'Installment Detail',
  'installment:detail:installmentAmount': 'Installment amount',
  'installment:detail:accountingPeriod': 'Accounting period',
  'installment:detail:interestRate': 'daily interest rate',
  'installment:detail:duration': 'duration of installment',
  'installment:detail:principal': 'principal',
  'installment:detail:interest': 'interest',
  'installment:detail:installmentPrincipal': 'installment principal',
  'installment:detail:installmentInterest': 'installment interest',
  'installment:detail:deadline': 'Repayment deadline',

  'installment:detail:installType': 'Installment Type',
  'installment:detail:installType1': 'Statement Installment',
  'installment:detail:installType2': 'Consumer installment',
  'installment:detail:createTime': 'Create Time',
  'installment:detail:installAmount': 'Total Cost',
  'installment:detail:stage': 'Total Period',
  'installment:detail:repaymentStatus': 'Status',
  'installment:detail:repaymentStatus1': 'in Progress',
  'installment:detail:repaymentStatus4': 'Completed',
  'installment:detail:currentPeriodStage': 'Current Period',
  'installment:detail:repaymentAmount': 'Total Paid Amount',
  'installment:detail:plan': 'Payment Plan',
  'installment:detail:planTotal': 'Payment Plan Total',
  'installment:detail:planDetail': 'Payment Plan Detail',
  'installment:detail:firstPay': 'Down Payment',
  'installment:detail:totalPrincipal': 'Total Principal',
  'installment:detail:totalFee': 'Total Fee',
  'installment:detail:totalInterest': 'Total Interest',
  'installment:detail:totalDiscount': 'Total Discount',
  'installment:detail:period': 'Period',
  'installment:detail:settleDate': 'Due Date',
  'installment:detail:principal': 'Principal',
  'installment:detail:fee': 'Fee',
  'installment:detail:interest': 'Interest',
  'installment:detail:discount': 'Discount',

  'depositRefund:detail:table': 'Refund of Guarantee Fee',
  'depositRefund:detail:createTime': 'Create Time',
  'depositRefund:detail:financeOrderIds': 'Original Guarantee Fee ID',
  'depositRefund:detail:depositAmount': 'Guarantee Fee  Amount',
  'depositRefund:detail:refundMethod': 'Type of Request',
  'depositRefund:detail:realAmount': 'Received Amount',
  'depositRefund:detail:lineBefore': 'Credit Before Refund',
  'depositRefund:detail:lineAfter': 'Credit After Refund',
  'depositRefund:detail:transferType': 'Type of Refund',
  'depositRefund:detail:creditedDate': 'Time of Refund',
  'depositRefund:detail:payOrderNo': 'Pay Out Transaction ID',
  'depositRefund:detail:status': 'Status of Refund or bill',
  'depositRefund:detail:status-1': 'Initiaed',
  'depositRefund:detail:status0': 'Pending',
  'depositRefund:detail:status1': 'Refund Success',
  'depositRefund:detail:status2': 'Refund Failed',
  'depositRefund:detail:status3': 'Need File OA',
  'depositRefund:detail:updateTime': 'Status Update time',
  'depositRefund:detail:accountType': 'Backup acount',
  'depositRefund:detail:realAccountNo': 'Backup acount number',
  'depositRefund:detail:reason': 'Refund Reason',
  'depositRefund:detail:suggestions': 'Comment',

  'qrph:qrCode': 'QR content',
  'qrph:qrContent': 'Decode Info',

  'shortLink:shortUrl': 'Short Url',
  'shortLink:originUrl': 'Origin Url',
  'shortLink:purpose': 'Purpose',
  'shortLink:linksNumber': 'Number of Links',

  'faq:title': 'FAQ Title',
  'faq:content': 'FAQ Content',
  'faq:contentView': 'FAQ Preview',
  'faq:category': 'Category',
  'faq:keyword': 'Keyword',
  'faq:isValid': 'Visible to Users',
  'faq:top': 'Stick to the Top',
  'faq:helpfulNumber': 'Helpful Number',
  'faq:uselessNumber': 'Useless Number',
  
  'product:enterSearch': 'Please enter keywords to search',
  'product:addCategoryBtn': 'Create Category',
  'product:addBrandBtn': 'Create Brand',
  'product:addProductBtn': 'Create Product',
  'product:addBtn': 'Create Category',
  'product:categoryName': 'Category Name',
  'product:productEntry': 'Product Entry',
  'product:categoryOrder': 'Category Order in Page',
  'product:order': 'Order',
  'product:category': 'Category',
  'product:categoryIcon': 'Category icon',
  'product:status': 'Status',
  'product:status0': 'Disabled',
  'product:status1': 'Enabled',
  'product:sureEnableTip': 'Please conifrm the detail before Publish',
  'product:sureDisableTip': 'Are you sure you are offline?',
  'product:brand': 'Brand',
  'product:brandName': 'Brand Name',
  'product:brandLogo': 'Brand Logo',
  'product:productName': 'Product Name',
  'product:channel': 'Vendor/Channel',

  'order:quickLoan:userName': 'User Name',
  'order:quickLoan:loanSerialNumber': 'Loan Serial Number',
  'order:quickLoan:applyDate': 'Apply Date',
  'order:quickLoan:disbursementDate': 'Disbursement Date',
  'order:quickLoan:completeDate': 'Complete Date',
  'order:quickLoan:applyAmount': 'Apply Amount',
  'order:quickLoan:receiveAmount': 'Received Amount',
  'order:quickLoan:status': 'Loan Status', 
  'order:quickLoan:status0': 'submitted',
  'order:quickLoan:status1': 'auditing',
  'order:quickLoan:status2': 'Disbursement in progress',
  'order:quickLoan:status3': 'Waiting for repayment',
  'order:quickLoan:status4': 'complete',
  'order:quickLoan:status5': 'reject',
  'order:quickLoan:status6': 'closed',
  'order:quickLoan:loanPayoutView': 'LoanPayout View',
  'order:quickLoan:loanId': 'Loan Id',
  'order:quickLoan:productId': 'Product Id',
  'order:quickLoan:term': 'Term',
  'order:quickLoan:termBeginDate': 'Term Begin Date',
  'order:quickLoan:termEndDate': 'Term End Date',
  'order:quickLoan:repaymentPlan:status': 'Status',
  'order:quickLoan:repaymentPlan:status1': 'To be repaid',
  'order:quickLoan:repaymentPlan:status2': 'Overdue',
  'order:quickLoan:repaymentPlan:status3': 'Paid in Full',
  'order:quickLoan:repaymentPlanView': 'Repayment Plan',
  'order:quickLoan:noRepaymentPlan': 'No Repayment Plan',
  'order:quickLoan:noOrders': 'No Orders',
  'order:quickLoan:noRepaymentRecord': 'No Repayment Record',
  'order:quickLoan:orderNumber': 'Order Number',
  'order:quickLoan:cardNumber': 'Card Number',
  'order:quickLoan:cardType': 'Card Type',
  'order:quickLoan:transactionNumber': 'Transaction Number',
  'order:quickLoan:receiptNumber': 'Receipt Number',
  'order:quickLoan:realAmount': 'Received Amount',
  'order:quickLoan:serviceFee': 'Service Fee',
  'order:quickLoan:convenienceFee': 'Convenience Fee',
  'order:quickLoan:privilegePackFee': 'PrivilegePack Fee',
  'order:quickLoan:feeList': 'Fee List',
  'order:quickLoan:feeName': 'Fee Name',
  'order:quickLoan:feeAmount': 'Fee Amount',
  'order:quickLoan:preDiscount': 'Discounted Fee',
  'order:quickLoan:discountInterest': 'Discounted Interest',
  'order:quickLoan:paymentMethod': 'Payment Method',
  'order:quickLoan:submitDate': 'Submit Date',
  'order:quickLoan:loanPayout:status': 'Status',
  'order:quickLoan:loanPayout:status0': 'To be released',
  'order:quickLoan:loanPayout:status1': 'pending',
  'order:quickLoan:loanPayout:status2': 'success',
  'order:quickLoan:loanPayout:status3': 'failed',
  'order:quickLoan:loanPayout:status4': 'Exception',
  'order:quickLoan:loanPaymentView': 'Repayment Record',
  'order:quickLoan:amount': 'Order Amount',
  'order:quickLoan:settleAmount': 'Settle Amount',
  'order:quickLoan:loanPayment:status': 'Status',
  'order:quickLoan:loanPayment:status0': 'initial',
  'order:quickLoan:loanPayment:status1': 'processing',
  'order:quickLoan:loanPayment:status2': 'success',
  'order:quickLoan:loanPayment:status3': 'failed',
  'order:quickLoan:loanPayment:applyDate': 'Repayment Time',
  'order:quickLoan:loanPayment:completeDate': 'User Paid Time',
  'order:quickLoan:operate:flatAccount': 'Balance',
  'order:quickLoan:remainAmount': 'Remain Amount',
  'order:quickLoan:balanceAmount': 'Amount',
  'order:quickLoan:remark': 'Remark',
  'order:quickLoan:receivedDate': 'Received Time',
  'order:quickLoan:institutionCode': 'Institution Code',
  'order:quickLoan:failReason': 'Fail Reason',
  'order:quickLoan:funderId': 'Funder Id',
  'order:quickLoan:payoutTransactionVoucher': 'Transaction Voucher',
  'order:cashoyoLoan:loanId': 'Loan ID',
  'order:cashoyoLoan:loanSerialNo': 'Loan Serial No',
  'order:cashoyoLoan:userType': 'User Type',
  'order:cashoyoLoan:userType1': 'Normal',
  'order:cashoyoLoan:userType2': 'Internal Employee',
  'order:cashoyoLoan:userType3': 'Auditor',
  'order:cashoyoLoan:productId': 'Product ID',
  'order:cashoyoLoan:principalPoolSessionCode': 'Principal Pool Session',
  'order:cashoyoLoan:payeeAccountNumber': 'Payee Account',
  'order:cashoyoLoan:days': 'Days',
  'order:cashoyoLoan:applyAmount': 'Apply Amount',
  'order:cashoyoLoan:serviceFee': 'Service Fee',
  'order:cashoyoLoan:convenienceFee': 'Convenience Fee',
  'order:cashoyoLoan:amount': 'Received Amount',
  'order:cashoyoLoan:remainingRepaymentAmount': 'Remaining Repayment Amount',
  'order:cashoyoLoan:applyTime': 'Apply Time',
  'order:cashoyoLoan:approvalTime': 'Loan Approval Time',
  'order:cashoyoLoan:billDueDate': 'Due Date',
  'order:cashoyoLoan:loanReceivedTime': 'Loan Received Time',
  'order:cashoyoLoan:completeTime': 'Complete Time',
  'order:cashoyoLoan:createTime': 'Create Time',
  'order:cashoyoLoan:updateTime': 'Update Time',
  'order:cashoyoLoan:status': 'Loan Status',
  'order:cashoyoLoan:status0': 'Machine Auditing',
  'order:cashoyoLoan:status1': 'Human Auditing',
  'order:cashoyoLoan:status2': 'Approved',
  'order:cashoyoLoan:status3': 'Disbursed',
  'order:cashoyoLoan:status4': 'Complete',
  'order:cashoyoLoan:status5': 'Rejected',
  'order:cashoyoLoan:status6': 'Closed',
  'order:cashoyoLoan:status7': 'Overdue',
  'order:cashoyoLoan:passConfirm': 'Are you sure to pass this loan?',
  'order:cashoyoLoan:rejectConfirm': 'Are you sure to reject this loan?',
  'order:cashoyoLoan:batchPass': 'Batch Pass',
  'order:cashoyoLoan:batchReject': 'Batch Reject',
  'order:cashoyoLoan:humanAuditOnlyTip': 'Only human auditing loans can be operated. Please check.',
  'order:cashoyoLoan:loanInfo': 'Loan Info',
  'order:cashoyoLoan:payouts': 'Payouts',
  'order:cashoyoLoan:plans': 'Plans',
  'order:cashoyoLoan:repayments': 'Repayments',
  'order:cashoyoLoan:statements': 'Statements',
  'order:cashoyoLoan:payoutSerialNumber': 'Payout Serial No',
  'order:cashoyoLoan:payoutReceipt': 'Payout Receipt',
  'order:cashoyoLoan:payoutTransactionVoucher': 'Payout Voucher',
  'order:cashoyoLoan:institutionCode': 'Institution Code',
  'order:cashoyoLoan:loanAmount': 'Loan Amount',
  'order:cashoyoLoan:realAmount': 'Real Amount',
  'order:cashoyoLoan:payoutStatus': 'Payout Status',
  'order:cashoyoLoan:payoutMessage': 'Payout Message',
  'order:cashoyoLoan:submitTime': 'Submit Time',
  'order:cashoyoLoan:planAmount': 'Plan Amount',
  'order:cashoyoLoan:principal': 'Principal',
  'order:cashoyoLoan:interest': 'Interest',
  'order:cashoyoLoan:penaltyInterest': 'Penalty Interest',
  'order:cashoyoLoan:paidPrincipal': 'Paid Principal',
  'order:cashoyoLoan:paidInterest': 'Paid Interest',
  'order:cashoyoLoan:paidPenaltyInterest': 'Paid Penalty Interest',
  'order:cashoyoLoan:interestRate': 'Interest Rate',
  'order:cashoyoLoan:penaltyRate': 'Penalty Rate',
  'order:cashoyoLoan:penaltyTimes': 'Penalty Times',
  'order:cashoyoLoan:initDueDate': 'Initial Due Date',
  'order:cashoyoLoan:dueDate': 'Due Date',
  'order:cashoyoLoan:remainingExtensionTimes': 'Remaining Extension Times',
  'order:cashoyoLoan:planStatus': 'Plan Status',
  'order:cashoyoLoan:planStatus1': 'Pending',
  'order:cashoyoLoan:planStatus2': 'Overdue',
  'order:cashoyoLoan:planStatus3': 'Settled',
  'order:cashoyoLoan:paySerialNo': 'Pay Serial No',
  'order:cashoyoLoan:payOrderNo': 'Pay Order No',
  'order:cashoyoLoan:repaymentStatus': 'Repayment Status',
  'order:cashoyoLoan:repaymentStatus0': 'Initial',
  'order:cashoyoLoan:repaymentStatus1': 'Processing',
  'order:cashoyoLoan:repaymentStatus2': 'Success',
  'order:cashoyoLoan:repaymentStatus3': 'Failed',
  'order:cashoyoLoan:payChannel': 'Pay Channel',
  'order:cashoyoLoan:payMode': 'Pay Mode',
  'order:cashoyoLoan:tradeFinishTime': 'Trade Finish Time',
  'order:cashoyoLoan:remark': 'Remark',
  'order:cashoyoLoan:settleAmount': 'Settle Amount',
  'order:cashoyoLoan:clearPrincipal': 'Clear Principal',
  'order:cashoyoLoan:clearInterest': 'Clear Interest',
  'order:cashoyoLoan:clearPenaltyInterest': 'Clear Penalty Interest',
  'order:cashoyoLoan:leftPrincipal': 'Left Principal',
  'order:cashoyoLoan:leftInterest': 'Left Interest',
  'order:cashoyoLoan:leftPenaltyInterest': 'Left Penalty Interest',

  'order:debtBuybackTable:time': 'ID Creation Date',
  'order:debtBuybackTable:funder': 'Capital Side',
  'order:debtBuybackTable:status': 'Buyback Status',
  'order:debtBuybackTable:status1': 'Pending',
  'order:debtBuybackTable:status2': 'Overdue',
  'order:debtBuybackTable:status3': 'Completed',
  'order:debtBuybackTable:leftDays': '[n] Day(s) Left',
  'order:debtBuybackTable:overDueDays': '[n] Day(s) Overdue ',
  'order:debtBuybackTable:cycle': 'Cycle',
  'order:debtBuybackTable:buybackAmount': 'Buyback Amount',
  'order:debtBuybackTable:latestOperatorName': 'Latest Operator',
  'order:debtBuybackTable:latestOperatorTime': 'Latest Operation',
  'order:debtBuybackTable:operate': 'Actions Available',
  'order:debtBuybackTable:operate:checklist': 'Checklist',
  'order:debtBuybackTable:operate:agreement': 'Agreement',
  'order:debtBuybackTable:operate:register': 'Register',
  'order:debtBuybackTable:operate:credentials': 'Credentials',
  'order:debtBuybackTable:operate:registerDialogTitle': 'Register for Buyback',
  'order:debtBuybackTable:operate:credentialsDialogTitle': 'Buyback Credentials',  
  'order:debtBuybackTable:quantity': 'Quantity',
  'order:debtBuybackTable:ticketTip': 'Upload the B2B Transfer or Topup Receipt (Required, Image Only)',
  'order:debtBuybackTable:contractTip': 'Upload the Buyback Agreement Signed by Both Parties (Required, PDF Only)',
  'order:debtBuybackTable:warningTip': 'You will set all overdue loans in this period as <span class="warning">REPO</span>. Please confirm the capital side, time range, number of loans and buyback amount again.',
  'order:debtBuybackTable:completedTip': '[operator] bought back this batch of debt at [operateTime].',
  'order:debtBuybackTable:registerDialog:submit': 'Confirm to REPO the Above Debt',
  'order:debtBuybackTable:imgTip': 'Only the following image formats are supported: .jpg / .jpeg / .png / .bmp / .tiff / .tif',
  'order:debtBuybackTable:pdfTip': 'Only supports PDF format',

  'mpay:transactionFinishDate': 'Transaction FinishDate',
  'mpay:createDate': 'Create Date',
  'mpay:cashflow': 'Cash Flow',
  'mpay:type': 'Type',
  'mpay:merchantName': 'Merchant Name',
  'mpay:institutionName': 'Institution Name',
  'mpay:institutionAccountName': 'Institution Account Name',
  'mpay:transactionNumber': 'Transaction Number',
  'mpay:transactionVoucher': 'Transaction Voucher',
  'mpay:processStatus': 'Process Status',
  'mpay:status': 'Status',
  'mpay:beforeStatus': 'Before Status',
  'mpay:channel': 'Channel',
  'mpay:originData': 'Origin Data',
  'mpay:remark': 'Remark',
  'mpay:operatorId': 'Operator Id',
  'mpay:operatorName': 'Operator Name',
  'mpay:totalMoneyIn': 'Money In',
  'mpay:totalMoneyOut': 'Money Out',
  'mpay:totalDiff': 'Diff',
  'mpay:all:totalMoneyIn': 'Total Money In',
  'mpay:all:totalMoneyOut': 'Total Money Out',
  'mpay:all:totalDiff': 'Total Diff',
  'mpay:all:totalDiffIn': 'Total Diff In',
  'mpay:all:totalDiffOut': 'Total Diff Out',


  'funder:router:name': 'Funder',
  'funder:router:expression': 'Expression',
  'funder:router:lastFunderExpression': 'Last Funder Expression',
  'funder:router:payActive': 'Pay Active',
  'funder:router:payoutActive': 'Payout Active',
  'funder:router:listOrder': 'List Order',
}
export default en
